import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';

@Component({
    selector: 'app-menu-side-toggle-competence',
    templateUrl: './menu-side-toggle-competence.component.html',
    styleUrls: ['./menu-side-toggle-competence.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideToggleCompetenceComponent implements OnInit {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    constructor() {}

    ngOnInit(): void {}
}
